import { httpGet } from '../../../tools/http/httpClient';
import { getAuthToken } from '../../../tools/session/clientSession';

let cachedToken;
let cachedUser;
let pendingRequest;

export function clearCurrentUserCache() {
  cachedToken = undefined;
  cachedUser = undefined;
  pendingRequest = undefined;
}

export function fetchCurrentUser() {
  const token = getAuthToken();
  if (cachedUser !== undefined && token === cachedToken) {
    return Promise.resolve(cachedUser);
  }
  if (pendingRequest && token === cachedToken) {
    return pendingRequest;
  }
  cachedToken = token;
  const requestToken = token;
  const request = httpGet('/api/auth/me', { loadingKey: 'auth-me' })
    .then((user) => {
      if (cachedToken === requestToken) cachedUser = user;
      return user;
    })
    .catch((error) => {
      if (cachedToken === requestToken) cachedUser = undefined;
      throw error;
    })
    .finally(() => {
      if (pendingRequest === request) pendingRequest = undefined;
    });
  pendingRequest = request;
  return request;
}
